// src/features/auth/components/AuthLayout.tsx
import React from 'react';

interface AuthLayoutProps {
  formSlot: React.ReactNode;
  // You can add a prop for the right panel content if it needs to be dynamic
  // marketingSlot?: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ formSlot }) => {
  return (
    <div className="flex relative min-h-screen bg-theme-bg dark:bg-dark-theme-bg">
      {/* Theme toggle removed - now in BackgroundControls */}
      {/* Left Panel: Form Area */}
      <div className="flex flex-col justify-center items-center p-8 w-full md:w-1/2 sm:p-12">
        <div className="w-full max-w-md">
          {/* Logo or App Name can go here */}
          <div className="mb-8 text-center">
          </div>
          {formSlot}
        </div>
      </div>

      {/* Right Panel: Promotional/Marketing Area */}
      <div className="hidden overflow-hidden relative justify-center items-center p-12 w-1/2 text-white bg-gradient-to-br to-blue-800 from-primary-light md:flex dark:from-primary-dark dark:to-gray-800">
        {/* Example content - replace with your actual marketing content or image */}
        <div className="z-10 text-center">
          <h2 className="mb-4 text-4xl font-bold">
            Welcome to the future!
          </h2>
          <p className="mb-6 text-lg">
            Join us and discover a seamless experience. Manage your ETL processes with ease and efficiency.
          </p>
          {/* You could add an illustration or more marketing points here */}
        </div>
        {/* Optional: Decorative background elements */}
        <div className="absolute -top-20 -left-20 w-72 h-72 rounded-full opacity-50 filter blur-xl animate-pulse bg-white/10"></div>
        <div className="absolute -right-10 -bottom-20 w-96 h-96 rounded-full opacity-40 filter blur-2xl animate-pulse bg-white/10 animation-delay-2000"></div>
      </div>
    </div>
  );
};

export default AuthLayout;
